import styled from 'styled-components';
import IronAndIroningBoardIconSvg from '../../assets/hotels/amenities/IronAndIroningBoard.svg';

const IronAndIroningBoard = styled(
  IronAndIroningBoardIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default IronAndIroningBoard;
